export const environment = {
    apiUrl: 'https://sociable-back.trevenque.es/api/',
    nodeInactiveThreshold: 60, // Minutes
}